import dateFormatterHelpers from './dateFormatterHelpers';
const { generateFormattedDate } = dateFormatterHelpers || {};

const generateGetAutomationErrorLogsApiPayload = (filterValuesObj = {}, last_updated_format) => {
  let automationErrorStartDate = '';
  let automationErrorEndDate = '';
  let payloadObj = {};

  if (filterValuesObj?.createdDate?.length) {
    automationErrorStartDate = filterValuesObj?.createdDate?.[0];
    automationErrorEndDate = filterValuesObj?.createdDate?.[1];
  }

  payloadObj = {
    case_id: [...(filterValuesObj?.case_lead || [])],
    error_code: filterValuesObj?.errorCode || [],
    automation_error_start_date: generateFormattedDate(automationErrorStartDate, last_updated_format),
    automation_error_end_date: generateFormattedDate(automationErrorEndDate, last_updated_format),

    status: filterValuesObj?.status || '',
  };

  return payloadObj || {};
};

export default generateGetAutomationErrorLogsApiPayload;
